module.exports = __webpack_public_path__ + "img/广告头部背景图.77d218d6.png";